import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IExecutionSet, ITestStepRun, ItTestCaseRun, ItestStepDetailDefect } from './Execute.type';
import { getSettingAPI } from 'app/services/api/bug';

export interface ExecuteState {
  isUpdateTestCase: boolean;
  isReloadAssignedExecution: boolean;
  isReloadSelectedExecutionCycle: boolean;
  executionSetId: number;
  executionSetRunId: number;
  execuTetestCaseId: number;
  testCaseRunId: number;
  testCaseDetail: ItTestCaseRun;
  testCaseDetailTitle: string;
  testStepId: number;
  testStepRunId: number;
  testStepDetailDefect: ItestStepDetailDefect;
  filterYourAssignedExecution: any;
  selectedExecutionSet: any;
  isUpdateTestStepDefect: boolean;
  testCaseStep: ITestStepRun;
  listExecutionCycles: any;
  listTestCaseSteps: any;
  filterAssignedExecution: boolean;
  onFolderID: boolean;
  isShowAllFilterExe: boolean;
}

const getStoredExecuteFilter = () => {
  try {
    const storedUser = localStorage.getItem('screenView');
    const screenView = storedUser ? JSON.parse(storedUser) : {};
    return screenView?.executeFilter;
  } catch (error) {
    return undefined;
  }
};

const storedExecuteFilter = getStoredExecuteFilter();

const initialState: ExecuteState = {
  isUpdateTestCase: false,
  isReloadAssignedExecution: false,
  isReloadSelectedExecutionCycle: false,
  executionSetId: 0,
  executionSetRunId: 0,
  execuTetestCaseId: 0,
  testCaseRunId: 0,
  testCaseDetail: {} as Required<ItTestCaseRun>,
  testCaseDetailTitle: '',
  testStepId: 0,
  testStepRunId: 0,
  testStepDetailDefect: {} as Required<ItestStepDetailDefect>,
  filterYourAssignedExecution: storedExecuteFilter?.filterYourAssignedExecution ?? [],
  selectedExecutionSet: {},
  isUpdateTestStepDefect: false,
  testCaseStep: {} as Required<ITestStepRun>,
  listExecutionCycles: [],
  listTestCaseSteps: [],
  filterAssignedExecution: storedExecuteFilter?.filterAssignedExecution ?? true,
  onFolderID: false,
  isShowAllFilterExe: false,
};

export const getSetting = createAsyncThunk('release/getSetting', async () => {
  const response = await getSettingAPI();
  return response;
});

export const executeSlice = createSlice({
  name: 'execute',
  initialState,

  reducers: {
    triggerIsUpdateTestCase: state => {
      state.isUpdateTestCase = !state.isUpdateTestCase;
    },
    triggerIsReloadAssignedExecution: state => {
      state.isReloadAssignedExecution = !state.isReloadAssignedExecution;
    },
    triggerIsReloadSelectedExecutionCycle: state => {
      state.isReloadSelectedExecutionCycle = !state.isReloadAssignedExecution;
    },
    setExecutionSetId: (state, action) => {
      state.executionSetId = action.payload;
    },
    setExecutionSetRunId: (state, action) => {
      state.executionSetRunId = action.payload;
    },
    setExecuteTestCaseId: (state, action) => {
      state.execuTetestCaseId = action.payload;
    },
    setTestCaseRunId: (state, action) => {
      state.testCaseRunId = action.payload;
    },
    settestCaseDetail: (state, action) => {
      state.testCaseDetail = action.payload;
    },
    setSelectedExecutionSet: (state, action) => {
      state.selectedExecutionSet = action.payload;
    },
    setTestStepId: (state, action) => {
      state.testStepId = action.payload;
    },
    setFilterYourAssignedExecution: (state, action) => {
      state.filterYourAssignedExecution = action.payload;
    },
    setFilterAssignedExecution: (state, action) => {
      state.filterAssignedExecution = action.payload;
    },
    setTestStepRunId: (state, action) => {
      state.testStepRunId = action.payload;
    },
    setTestStepDetailDefect: (state, action) => {
      state.testStepDetailDefect = action.payload;
    },
    setTestCaseStep: (state, action) => {
      state.testCaseStep = action.payload;
    },
    setListExecutionCycles: (state, action) => {
      state.listExecutionCycles = action.payload;
    },
    setListTestCaseSteps: (state, action) => {
      state.listTestCaseSteps = action.payload;
    },
    clearTestStepDetailDefect: state => {
      state.testStepDetailDefect = initialState.testStepDetailDefect;
    },
    triggerIsUpdateTestStepDefect: state => {
      state.isUpdateTestStepDefect = !state.isUpdateTestStepDefect;
    },
    triggerIsShowAllFilterExe: state => {
      state.isShowAllFilterExe = !state.isShowAllFilterExe;
    },
    setOnFolderID: (state, action) => {
      state.onFolderID = action.payload;
    },
  },
  extraReducers: builder => {},
});

export const {
  setListExecutionCycles,
  setListTestCaseSteps,
  triggerIsUpdateTestCase,
  triggerIsReloadAssignedExecution,
  triggerIsReloadSelectedExecutionCycle,
  setExecutionSetId,
  setExecutionSetRunId,
  setTestCaseRunId,
  setExecuteTestCaseId,
  settestCaseDetail,
  setSelectedExecutionSet,
  setTestStepId,
  setTestCaseStep,
  setFilterYourAssignedExecution,
  setFilterAssignedExecution,
  setTestStepRunId,
  setTestStepDetailDefect,
  clearTestStepDetailDefect,
  triggerIsUpdateTestStepDefect,
  setOnFolderID,
  triggerIsShowAllFilterExe,
} = executeSlice.actions;

export default executeSlice.reducer;
